<style src="./SuppliersMap.scss" lang="scss" scoped></style>
<template>
  <ul class="grid-list-container">
    <li
      class="grid-row"
      v-for="(item, itemIdx) in list"
      :key="itemIdx"
      @click="editItem({ item, itemIdx })">
      <div class="info-1">
        <span class="name">{{ item.name }}</span>
      </div>
    </li>
  </ul>
</template>

<script>
export default {
  name: 'SuppliersMap',
  props: {
    list: {
      default: () => ([])
    }
  },
  data () {
    return {}
  },
  methods: {
    editItem ({ item, itemIdx }) {
      const supplierId = item._id
      const supplierName = item.name
      this.$store.commit('Suppliers/SELECT_SUPPLIER', { supplierName })
      this.$router.push({ name: 'SuppliersEditor', params: { supplierId } })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/record/suppliers/suppliers-listing/components/suppliers-map/SuppliersMap.vue